/**
 * 将一个整数转换为分数保留两位小数
 * @param num
 */
export const formatToFraction = (num) => {
	if (typeof num === 'undefined') return '0.00'
	const parsedNumber = typeof num === 'string' ? parseFloat(num) : num
	return (parsedNumber / 100.0).toFixed(2)
}

/**
 * 将一个数转换为 1.00 这样
 * 数据呈现的时候使用
 *
 * @param num 整数
 */
export const floatToFixed2 = (num) => {
	let str = '0.00'
	if (typeof num === 'undefined') {
		return str
	}
	const f = formatToFraction(num)
	const decimalPart = f.toString().split('.')[1]
	const len = decimalPart ? decimalPart.length : 0
	switch (len) {
		case 0:
			str = f.toString() + '.00'
			break
		case 1:
			str = f.toString() + '0'
			break
		case 2:
			str = f.toString()
			break
	}
	return str
}

/**
 * 将元转换为分
 * @param num 元数
 */
export const convertToInteger = (num) => {
	if (typeof num === 'undefined' || num === null) return 0
	const parsedNumber = typeof num === 'string' ? parseFloat(num) : num
	return Math.round(parsedNumber * 100)
}

/**
 * 将值复制到目标对象，且以目标对象属性为准，例：target: {a:1} source:{a:2,b:3} 结果为：{a:2}
 * @param target 目标对象
 * @param source 源对象
 */
export const copyValueToTarget = (target, source) => {
	const newObj = Object.assign({}, target, source)
	// 删除多余属性
	Object.keys(newObj).forEach((key) => {
		// 如果不是target中的属性则删除
		if (Object.keys(target).indexOf(key) === -1) {
			delete newObj[key]
		}
	})
	// 更新目标对象值
	Object.assign(target, newObj)
}